import React, {useState, useEffect} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Input, Avatar, Modal, Card } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image, View, Platform } from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import * as RootNavigation from '../../../root.navigation.js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {saveInfo} from '../../../store/actions/login'
import JalaliCalendarPicker from 'react-native-persian-jalali-calendar-picker';

import { useDispatch, useSelector} from 'react-redux';
import trackerApi from '../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";
import {updateImageUri} from '../../../store/actions/login'

const width = Dimensions.get('window').width-40;



const CameraIcon = (props) => (
  <Icon {...props} name='camera' />
);


const FileIcon = (props) => (
  <Icon {...props} name='folder' />
);

const EmailIcon = (props) => (
  <Icon {...props} name='email' />
);
const CardIcon = (props) => (
  <Icon {...props} name='credit-card' />
);
const BirthIcon = (props) => (
  <Icon {...props} name='gift' />
);

const CheckIcon = (props) => (
  <Icon {...props} name='checkmark-circle'  fill='#A0D308' style={{width:60, height:60, marginTop:30, marginBottom:10}}/>
);

const TelIcon = (props) => (
  <Icon {...props} name='phone' />
);

const MobileIcon = (props) => (
  <Icon {...props} name='smartphone' />
);

const AddressIcon = (props) => (
  <Icon {...props} name='compass-outline' />
);

export const EditProfile = () => {

  const [profileUri, setProfileUri] = useState(null);
  const [cardUri,setCardUri] = useState(null);

  const [phoneStatus, setPhoneStatus] = useState('');
  const [bank, setBank] = useState('');
  const [telephoneStatus, setTelephoneStatus] = useState('');
  const [homeAddressStatus, setHomeAddressStatus] = useState('');
  const [workAddressStatus, setWorkAddressStatus] = useState('');
  const [visible, setVisible] = useState(false);
  const [bdstatus, setBdstatus] = useState('basic');
  const [selectedBirthDate, setSeletedBirthDate] = React.useState(null)
  const [dateModal, setDateModal] = React.useState(false)

  const [birthday, setBirthday] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');
  const [homeAddress, setHomeAddress] = useState('');
  const [workAddress, setWorkAddress] = useState('');

  const user =  useSelector( state => state.login.information);
  const dispatch = useDispatch();

  useEffect(()=>{
    setEmail(user.email);
    setTelephone(user.telephone);
    setHomeAddress(user.home_address);
    setWorkAddress(user.work_address);
    setBank(user.bank);
    setSeletedBirthDate(user.birthday)
  },[])

  const pickCardImage = async () => {
      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [4, 3],
        quality: 0.4,
      });

      if (!result.cancelled) {
        console.log('result: ', result.assets[0].uri);
      setCardUri(result.assets[0].uri);
      uploadCard(result.assets[0].uri);

    }
  }
  const uploadCard = async (imageUri)=>{
    console.log('Platform.OS');
    console.log(Platform.OS);
    let formdata = new FormData();
    await formdata.append('file',JSON.stringify({
        uri: imageUri,
        name: user.phone.toString(),
        type: 'image/jpg' // or your mime type what you want
    }));
    // console.log(formdata._parts);
    const response = await trackerApi.post('/webcardImagePicker', formdata, {   headers: { "Content-Type": "multipart/form-data" }})
    console.log(response);
    if(response.status == 500){
      console.log('Picking');
      return showMessage({
        message: response.data,
        type: "warning",
      });
    }
    else{
      console.log('Picking2');
      setVisible(false)
      showMessage({
        message: 'با موفقیت بارگذاری شد',
        type: "success",
      });
      dispatch(updateImageUri(response.data.uri));

      // setCardSelected(true)
    }

    // readData();
  }
  const uploadProfile = async (imageUri)=>{
    let formdata = new FormData();
    await formdata.append('file',JSON.stringify({
        uri: imageUri,
        name: user.phone.toString(),
        type: 'image/jpg' // or your mime type what you want
    }));

    const response = await trackerApi.post('/webimagePicker', formdata, {   headers: { "Content-Type": "multipart/form-data" }})
    // console.log(response.data);
    if(response.status == 500){
      return showMessage({
        message: response.data,
        type: "warning",
      });
    }
    showMessage({
      message: 'با موفقیت بارگذاری شد',
      type: "success",
    });
    dispatch(updateImageUri(response.data.uri));
    // readData();
  }

  const pickProfileImage = async () => {
      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.4,
      });
      if (!result.cancelled) {
      setProfileUri(result.assets[0].uri);
      console.log(result.assets[0].uri);
      uploadProfile(result.assets[0].uri);
    }
}

const takeProfileImage = async () => {
      let result = await ImagePicker.launchCameraAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.4,
        base64: true
      });

      // console.log(result);

      if (!result.cancelled) {
        setProfileUri(result.assets[0].uri);
        uploadProfile(result.assets[0].uri);

      }
    };

  const saveChanges = async ()=>{
    if(telephone.length==11&& homeAddress.length>4 && workAddress.length>4 && selectedBirthDate){
      const token =  await AsyncStorage.getItem('userId');
      const response = await trackerApi.post('/update/agentprofile',{homeAddress,workAddress, email, telephone, bank, birthday: selectedBirthDate} , {
        headers: {Authorization: `Bearer ${token}`}
      });
      if(response.data.status){
        showMessage({
          message: response.data.message,
          type: "success",
        });
        await dispatch(saveInfo(response.data.user))

      } else {

        showMessage({
          message: 'خطای سرور',
          type: "danger",
        });
      }
    } else {
      if(!selectedBirthDate) setBdstatus('danger')
      showMessage({
        message: 'لطفا اطلاعات را با دقت وارد نمایید',
        type: "warning",
      });
    }
  }

  return (
    <Layout level='3' style={styles.container}>
    <SafeAreaView>
        <View style={{alignItems:'center', justifyContent:'space-between'}}>
        <Text style={{marginVertical:20}} status='primary' category='h5'> ویرایش حساب کاربری </Text>
        <ScrollView showsVerticalScrollIndicator={false}>
        <View style={{alignItems:'center'}}>
        <Text>{user.firstname +' '+ user.lastname }</Text>
        <Text appearance='hint'> کد تکنسین: {user.id}</Text>
        <View style={{flexDirection:'row', justifyContent:'space-around', alignItems:'center', width,marginTop:20}}>
          <Avatar
            style={{width:width*0.4,height:width*0.4, borderWidth:3, borderColor:'#417CBE'}}
            source={{uri: `https://api.fntpf.ir/assets/uploaded/images/${user.img_uri}`}}
            size='giant'
            />
          <View>
            <Button style={{borderRadius:10, marginBottom:10}} appearance='outline' accessoryLeft={CameraIcon} onPress={takeProfileImage}> دوربین</Button>
            <Button style={{borderRadius:10, marginBottom:10}} appearance='outline' accessoryLeft={FileIcon} onPress={pickProfileImage}> گالری</Button>
            <Button style={{borderRadius:10}} appearance='outline' onPress={() => setVisible(true)}>تصویر کارت ملی</Button>
          </View>
        </View>
        <View style={{justifyContent:'flex-start', width, marginTop:15}}>
        <Input
          style={{ margin:8}}
          label={evaProps => <Text {...evaProps}>شماره همراه</Text>}
          placeholder ='شماره همراه'
          value={user.phone}
          accessoryLeft={MobileIcon}
          status = { phoneStatus}
          disabled
          keyboardType='numeric'
          />
          <Input
            style={{ margin:8}}
            label={evaProps => <Text {...evaProps}>تاریخ تولد</Text>}
            placeholder ='1402/01/01'
            value={selectedBirthDate}
            accessoryLeft={BirthIcon}
            keyboardType='numeric'
            status= {bdstatus}
            onTouchStart = {() =>{ setDateModal(true)}}
            onChangeText = {newValue =>{ setDateModal(true)}}
            />
            <Input
              style={{ margin:8}}
              label={evaProps => <Text {...evaProps}>آدرس ایمیل</Text>}
              placeholder ='ایمیل'
              value={email}
              accessoryLeft={EmailIcon}
              keyboardType='email'
              onChangeText = {newValue =>{ setEmail(newValue)}}
              />
            <Input
              style={{ margin:8}}
              label={evaProps => <Text {...evaProps}>شماره کارت بانکی</Text>}
              placeholder ='اطلاعات بانکی'
              value={bank}
              accessoryLeft={CardIcon}
              onChangeText = {newValue =>{ setBank(newValue)}}
              />
          <Input
            style={{ margin:8}}
            label={evaProps => <Text {...evaProps}>شماره ثابت با کد شهر</Text>}
            placeholder ='شماره ثابت'
            value={telephone}
            accessoryLeft={TelIcon}
            onChangeText = {newValue =>{
              setTelephone(newValue)
              if(newValue.length==0) setTelephoneStatus('danger')
              else setTelephoneStatus('basic')
            }}
            status = { telephoneStatus}
            keyboardType='numeric'
            maxLength={11}
            />
        <Input
          style={{ margin:8}}
          label={evaProps => <Text {...evaProps}>آدرس محل سکونت</Text>}
          placeholder ='آدرس را کامل وارد نمایید'
          value={homeAddress}
          accessoryLeft={AddressIcon}
          multiline={true}
          onChangeText = {newValue =>{
            setHomeAddress(newValue)
            if(newValue.length<5) setHomeAddressStatus('danger')
            else setHomeAddressStatus('basic')
          }}
          status = { homeAddressStatus}
          />

          <Input
            style={{ margin:8}}
            label={evaProps => <Text {...evaProps}>آدرس محل کار</Text>}
            placeholder ='آدرس را کامل وارد نمایید'
            value={workAddress}
            accessoryLeft={AddressIcon}
            multiline={true}
            onChangeText = {newValue =>{
              setWorkAddress(newValue)
              if(newValue.length<5) setWorkAddressStatus('danger')
              else setWorkAddressStatus('basic')
            }}
            status = {workAddressStatus}
            />
            </View>

            </View>
          </ScrollView>
          <View style={{flexDirection:'row' ,width: width-20, marginTop:15, marginBottom:30}} >
          <Button
            appearance='ghost'
            style={{flex:2, marginRight:15}}
            onPress={()=>{RootNavigation.navigate('Menu')}}
             >بازگشت</Button>
          <Button style={{flex:3}} onPress={saveChanges} >ذخیره تغییرات</Button>
          </View>
        </View>
        <Modal
        visible={visible}
        backdropStyle={styles.backdrop}
        onBackdropPress={() => setVisible(false)}
      >
        <Card disabled={true}>
          <View style={{alignItems:'center'}}>
          <Text status='primary' category='h6'>
            تصویر کارت ملی
          </Text>
          { user.idcard_uri ?
          <Image
            style={{width: 0.7*width, height: width*0.7/1.69 }}
            source={{uri: `https://api.fntpf.ir/assets/uploaded/cards/${user.idcard_uri}`}}
          /> : <Text >
            تصویر کارت ملی وجود ندارد .
          </Text>
        }
          <View style={{flexDirection:'row', justifyContent:'space-between' ,width: width-40, marginTop:15}} >
            <Button appearance='outline' onPress={() => setVisible(false)}>
              بازگشت
            </Button>
            <Button style={{flex:1, marginHorizontal:10}} onPress={()=> {pickCardImage()}}>
              افزودن تصویر
            </Button>
          </View>
          </View>
        </Card>
      </Modal>
      <Modal
         visible={dateModal}
         style={{width:width-20}}
         backdropStyle={styles.backdrop}
         onBackdropPress={() => setDateModal(false)}>
         <Card disabled={false} style={{backgroundColor:'#f5f5f5'}}>
         <JalaliCalendarPicker onDateChange={date => {
           setSeletedBirthDate(date)
           setDateModal(false)
           }
         }
           minY='1320'
           headerStyleText={{fontFamily: 'IRANYekanBold'}}
           weekStyleText={{fontFamily: 'IRANYekanBold'}}
           headerStyleTextCenter={{fontFamily: 'IRANYekanBold'}}
         />
         </Card>
       </Modal>
    </SafeAreaView>
    </Layout>


  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between'
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});
